import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  TrackingAsesoresDispatcher,
  trackingAsesoresDispatcher
} from "./TrackingAsesores.dispatcher";
import {
  TrackingAsesoresStore,
  trackingAsesoresStore
} from "./TrackingAsesores.store";
import TrackingAsesoresComponent from "../../../components/comisionesMembresiaConfiguracion/trackingAsesores";

interface Props extends TrackingAsesoresStore, TrackingAsesoresDispatcher {}

@ReduxConnect(trackingAsesoresStore, trackingAsesoresDispatcher)
export default class TrackingAsesoresContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Tracking de Asesores" />
          <TrackingAsesoresComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
